"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "search-bar-inner" };
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { key: 1 };
var _hoisted_4 = { class: "search-input-wrapper" };
var _hoisted_5 = ["value"];
var _hoisted_6 = { class: "filter-group" };
var _hoisted_7 = ["value"];
var _hoisted_8 = ["value"];
var _hoisted_9 = { class: "filter-group" };
var _hoisted_10 = ["value"];
var _hoisted_11 = { class: "results-count" };
var _hoisted_12 = { class: "count-badge" };
var vue_3 = require("vue");
var nurseCardsStore_1 = require("../../../stores/nurseCardsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NurseSearchBar',
    setup: function (__props) {
        var store = (0, nurseCardsStore_1.useNurseCardsStore)();
        var isExpanded = (0, vue_3.ref)(true);
        function handleSearch(e) {
            var target = e.target;
            store.setSearchQuery(target.value);
        }
        function clearSearch() {
            store.setSearchQuery('');
        }
        function handleFilterChange(e) {
            var target = e.target;
            store.setFilterTag(target.value || null);
        }
        function handleSortChange(e) {
            var target = e.target;
            store.setSortBy(target.value);
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["patient-search-bar", { expanded: isExpanded.value }])
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "search-toggle-btn",
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (isExpanded.value = !isExpanded.value); })
                    }, [
                        (0, vue_2.createElementVNode)("span", {
                            class: (0, vue_2.normalizeClass)(["glyphicon", isExpanded.value ? 'glyphicon-chevron-up' : 'glyphicon-search'])
                        }, null, 2),
                        (!isExpanded.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, "Search & Filter"))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_3, "Close"))
                    ]),
                    (0, vue_2.createElementVNode)("div", {
                        class: (0, vue_2.normalizeClass)(["search-controls", { visible: isExpanded.value }])
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-search search-icon" }, null, -1)),
                            (0, vue_2.createElementVNode)("input", {
                                type: "text",
                                class: "search-input",
                                placeholder: "Search nurses by name, email, phone, or MRN...",
                                value: (0, vue_2.unref)(store).searchQuery,
                                onInput: handleSearch
                            }, null, 40, _hoisted_5),
                            ((0, vue_2.unref)(store).searchQuery)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 0,
                                    class: "clear-btn",
                                    onClick: clearSearch
                                }, __spreadArray([], (_cache[1] || (_cache[1] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                ])), true)))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("label", null, "Filter by Condition:", -1)),
                            (0, vue_2.createElementVNode)("select", {
                                value: (0, vue_2.unref)(store).filterTag || '',
                                onChange: handleFilterChange
                            }, [
                                _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("option", { value: "" }, "All Nurses", -1)),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(store).allTags, function (tag) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                        key: tag,
                                        value: tag
                                    }, (0, vue_2.toDisplayString)(tag), 9, _hoisted_8));
                                }), 128))
                            ], 40, _hoisted_7)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("label", null, "Sort by:", -1)),
                            (0, vue_2.createElementVNode)("select", {
                                value: (0, vue_2.unref)(store).sortBy,
                                onChange: handleSortChange
                            }, __spreadArray([], (_cache[5] || (_cache[5] = [
                                (0, vue_2.createElementVNode)("option", { value: "name" }, "Name (A-Z)", -1),
                                (0, vue_2.createElementVNode)("option", { value: "licenseType" }, "License Type", -1),
                                (0, vue_2.createElementVNode)("option", { value: "caregiverType" }, "Caregiver Type", -1)
                            ])), true), 40, _hoisted_10)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(store).filteredNurses.length), 1),
                            (0, vue_2.createTextVNode)(" patient" + (0, vue_2.toDisplayString)((0, vue_2.unref)(store).filteredNurses.length !== 1 ? 's' : ''), 1)
                        ])
                    ], 2)
                ])
            ], 2));
        };
    }
});
